<template>
  <div class="payment-status">
    <div class="iconfont icon-duihao2 bg-color-theme"></div>
    <!-- 失败时：订单支付失败 -->
    <div class="status" v-if="isLoading">订单查询中...</div>
    <div v-else>
      <div class="status" v-if="status == 0">下单成功（待支付）</div>
      <div class="status" v-else>预约成功</div>
    </div>
    <div class="wrapper">
      <div
        class="item acea-row row-between-wrapper"
        v-if="status == 0"
        style="color: #ff1200; text-align: center"
      >
        {{ msg }}
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>订单编号</div>
        <div class="itemCom">{{ orderDetail.orderId }}</div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>下单时间</div>
        <div class="itemCom">{{ orderDetail.createTime }}</div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>支付方式</div>
        <div class="itemCom">微信支付</div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>订单金额</div>
        <div class="itemCom">￥{{ orderDetail.payPrice }}</div>
      </div>

      <!-- 添加套餐信息显示区域 -->
      <div v-if="hasPackageInfo &&packageInfo.onePrice>0 " class="package-info">
        <div class="package-title">套餐信息</div>
        <div class="item acea-row row-between-wrapper">
          <div>套餐名称</div>
          <div class="itemCom">{{ packageInfo.name }}</div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div>旅程次数</div>
          <div class="itemCom">{{ packageInfo.sku }} 次</div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div>单次价格</div>
          <div class="itemCom">¥{{ packageInfo.onePrice }}</div>
        </div>
      </div>
    </div>
    <!--失败时： 重新购买 -->
    <div
      class="returnBnt bg-color-theme"
      @click="
        $router.push({ path: '/order/detail/' + id, query: { from: 'order' } })
      "
    >
      查看订单
    </div>
    <div class="returnBnt cart-color" @click="$router.push('/')">返回首页</div>

    <template v-if="orderDetail.payPrice == 0">
      <div>
        <div>
          <div class="pay-bg">
            <img :src="orderDetail.zeroWechat" />
          </div>
          <div v-html="orderDetail.zeroDesc"></div>
        </div>
      </div>
    </template>

    <template v-else>
      <div v-if="!isLoading && status != 0">
        <div v-if="$route.query.type == '0'">
          <div class="pay-bg">
            <img :src="kefu" />
          </div>
          <!-- <div style="font-weight: 700;line-height: 1.8;color: #ff7733;margin-top: 0.2rem;padding:0.2rem;">
          下单成功！扫码添加蒲公英小管家，发送课程序号，即可领取平台赠送的价值299的音频课程。<br/>①<span style="color:#ff7733;font-weight:700">《青春期难题预防与实战解决》</span>音频课<br/>②<span style="color:#ff7733;font-weight:700">《用父母智慧点燃孩子的内驱力》</span>音频课<br/>③<span style="color:#ff7733;font-weight:700">《亲密关系》</span>教练demo音频。
        </div> -->
          <div v-html="orderDetail.payDesc"></div>
        </div>
        <div
          style="
            font-weight: 700;
            line-height: 1.8;
            color: #ff7733;
            margin-top: 0.2rem;
            padding: 0.2rem;
          "
          v-else
        >
          支付成功，目前正在等待教练确认（48小时内）。
          请您关注订单状态，如有问题请在首页咨询客服，感谢您的支持！
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { orderDetail } from "@api/order";
import { getXeQRcode } from "@api/public";
const NAME = "PaymentStatus";

export default {
  name: NAME,
  data: function () {
    return {
      id: this.$route.params.id,
      status: 1,
      msg: "",
      isLoading: true,
      kefu: "",
      orderDetail: {},
      hasPackageInfo: false,
      packageInfo: {},
    };
  },
  mounted: function () {
    this.getQRcodeImg();
    this.isLoading = true;
    this.getPackageInfo();
    setTimeout(() => {
      this.getDetail();
    }, 1000);
  },
  methods: {
    getPackageInfo() {
      const { packageName, packageSku, packageOnePrice } = this.$route.query;
      if (packageName) {
        this.hasPackageInfo = true;
        this.packageInfo = {
          name: packageName,
          sku: packageSku || '',
          onePrice: packageOnePrice || 0
        };
      }
    },
    getQRcodeImg: function () {
      getXeQRcode().then((res) => {
        this.kefu = res.data.value;
      });
    },
    getDetail() {
      const id = this.id;
      if (!id) return this.$dialog.error("订单不存在");
      orderDetail(id)
        .then((res) => {
          this.isLoading = false;
          this.msg = res.data._status._msg;
          this.status = res.data.status;
          this.orderDetail = res.data;

          // 如果后端返回了套餐信息，优先使用后端数据
          if (res.data.packageInfo && Object.keys(res.data.packageInfo).length > 0) {
            this.hasPackageInfo = true;
            this.packageInfo = res.data.packageInfo;
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.$dialog.error(err.msg);
        });
    },
  },
};
</script>
<style scoped lang="scss">
.pay-bg {
  // margin-top: 0.4rem;
  width: 100%;
  // height: 3.2rem;
  // background: url("~@/assets/img/pay_bg.png") no-repeat;
  background-size: 100%;
  background-position: center;
  text-align: center;
  img {
    width: 2.5rem;
    margin: 0.15rem 0.15rem 0 0;
  }
}

/* 套餐信息样式 */
.package-info {
  margin-top: 0.3rem;
  padding-top: 0.2rem;
  border-top: 1px dashed #eee;
  background-color: #f9ffff;
  border-radius: 0.2rem;
  padding: 0.3rem 0.2rem;
  box-shadow: 0 0.05rem 0.2rem rgba(12, 230, 223, 0.1);
}

.package-title {
  font-size: 0.32rem;
  font-weight: bold;
  color: #0ce6df;
  margin-bottom: 0.3rem;
  padding-left: 0.2rem;
  position: relative;
}

.package-title:before {
  content: '';
  position: absolute;
  left: 0;
  height: 0.36rem;
  width: 0.1rem;
  background-color: #0ce6df;
  border-radius: 0.04rem;
  top: 50%;
  transform: translateY(-50%);
}
</style>
